import { IShipmentIssueStates } from 'types/graphqlTypes'
import { TAG_STYLE } from 'transfix-ui'

export const statusSelectList = [
  {
    label: 'Pending',
    outlineOnly: true,
    style: TAG_STYLE.dark,
    value: IShipmentIssueStates.pending,
    description: 'Issue has been created',
  },
  {
    label: 'In Progress',
    style: TAG_STYLE.info,
    value: IShipmentIssueStates.in_progress,
    description: 'Now actively being worked on',
  },
  {
    label: 'Awaiting Response',
    style: TAG_STYLE.warning,
    value: IShipmentIssueStates.awaiting_response,
    description: 'Assistance being requested from outside party, owner awaiting response',
  },
  {
    label: 'Resolved',
    style: TAG_STYLE.success,
    value: IShipmentIssueStates.resolved,
    description: 'Issue is now closed',
  },
]
